export const accountMixin = {
  data() {
    return {
      account: {
        fullName: "",
        email: "",
        companyName: "",
        subscriptionType: "",
        subscribedCalendarUsers: "",
        createdOn: "",
        approved_products: {}
      }
    };
  },
  methods: {
    getAccountDetails: function() {
      return this.$http
        .get(process.env.VUE_APP_API_URL + "/account")
        .then(httpResponse => {
          this.account.fullName = httpResponse.data.fullname;
          this.account.email = httpResponse.data.email;
          this.account.companyName = httpResponse.data.company_name;
          this.account.subscriptionType = httpResponse.data.subscription_type;
          this.account.subscribedCalendarUsers =
            httpResponse.data.subscribed_calendar_users;
          this.account.createdOn = httpResponse.data.account_created_on;
          this.account.approved_products = httpResponse.data.approved_products;
        })
        .catch(httpError => {
          if (httpError.response.status == 401) {
            localStorage.removeItem("token");
            this.$router.push("/");
          }
        });
    }
  }
};
